<template>
  <div class="home">
    登录
  </div>
</template>

<script>

export default {

  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  height: 100vh;
}
</style>
